export const store = {
  state: {
    isProcessing: false,
    isInitLoading: false,
    isChildLoading: false,

    showAlert: false,
    alertMsg: '',
    alertVariant: '',
  },

  setIsProcessing(newValue) {
    this.state.isProcessing = newValue
  },
  setIsInitLoading(newValue) {
    this.state.isInitLoading = newValue
  },
  setIsChildLoading(newValue) {
    this.state.isChildLoading = newValue
  },
  clearProcessing() {
    this.state.isProcessing = false
    this.state.isChildLoading = false
  },
  isProcessing() {
    return this.state.isProcessing
  },

  hideAlert(){
    this.state.showAlert = false
    this.state.alertMsg = ''
    this.state.alertVariant = ''
  },
  showAlert(msg, variant) {
    this.state.showAlert = true
    this.state.alertMsg = msg
    this.state.alertVariant = variant
  }
}
